module.exports = __webpack_public_path__ + "img/CPT03.e786f922.svg";